import axios from "axios";
import { ApiHeaders } from "./Helper";
import { resolve } from "./Resolver";
import helper from "./Helper";
import { getStore } from "../redux/storeInjector";
import { logout } from "../features/auth/authSlice";
import { eventBus } from "./eventBus";

const apiInstance = axios.create({
  baseURL: helper.ApiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data?.message === "Unauthenticated.") {
      getStore()?.dispatch(logout());
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

const ApiCall = async (method, url, data = null, token = null) => {
  const isDeleteComment = url === "delete-dream-comment" && data?.id;
  if (isDeleteComment) {
    eventBus.emit("comment-deleting", { commentId: data.id, isDeleting: true });
  }

  const isSubmitReply = url === "dreams/comment" && data?.parent_id;
  if (isSubmitReply) {
    eventBus.emit("reply-submitting", {
      parentId: data.parent_id,
      isSubmitting: true,
    });
  }

  try {
    const headers = {
      ...ApiHeaders(token),
    };

    if (data instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    const response = await apiInstance({
      method,
      url,
      data,
      headers,
    });
    const resolved = await resolve(response.data);
    return resolved.error
      ? { data: { success: false, message: resolved.error.message } }
      : { data: resolved.data };
  } catch (error) {
    const resolved = await resolve(
      error.response?.data || { success: false, message: "Unknown error" },
    );
    return resolved.error
      ? { data: { success: false, message: resolved.error.message } }
      : { data: resolved.data };
  } finally {
    if (isDeleteComment) {
      eventBus.emit("comment-deleting", {
        commentId: data.id,
        isDeleting: false,
      });
    }
    if (isSubmitReply) {
      eventBus.emit("reply-submitting", {
        parentId: data.parent_id,
        isSubmitting: false,
      });
    }
  }
};

export default ApiCall;
